import { useContext } from "react";
import { PublicConfigurationContext } from "../../Context";
import { CustomAddButton } from "./AddApplicantButton";

export function CustomAddButtons () {
  const config = useContext(PublicConfigurationContext);

  const buttons = config?.capabilities?.customButtons || [];
  if (!buttons.length) {
    return <></>;
  }

  // For now the only custom buttons are add applicant buttons
  // Coming soon
  // -- Add User button
  // -- Add Organization button
  return <>
    {buttons.map((button) => <CustomAddButton key={button.buttonId} {...button} />)}
  </>
}